define(["jquery", "common/lib/accounting"], function($, accounting) {
	
	var numberFormattingSettings = {
		precision: 2
	};	
	
	//format controls output: %s = symbol, %v = value/number
	var currencies = {
		"CAD": {
			symbol: "$",
			format: "%s%v"
		},
		"USD": {
			symbol: "$",
			format: "%s%v"
		},
		"AUD": {
			symbol: "$",
			format: "%s%v"
		},
		"MXN": {
			symbol: "$",
			format: "%s%v"
		},
		"CNY": {
			symbol: "&yen;",
			format: "%s%v"
		},
		"EUR": {
			symbol: "&euro;",
			format: "%s%v"
		},
		"GBP": {
			symbol: "&pound;",
			format: "%s%v"
		},
		"INR": {
			symbol: "&#8360;",
			format: "%s%v"
		},
		"ILS": {
			symbol: "₪",
			format: "%s%v"
		},
		"JPY": {
			symbol: "&yen;",
			format: "%s%v"
		},
		"RUB": {
			symbol: "RUB",
			format: "%v %s"
		}
	};

    function formatCurrency(num, code, precision) {
        var options = currencies[code];
        if(!options) return null;

        if(precision) {
            options.precision = precision;
        }

        return accounting.formatMoney(num, options);
    }

	return {
        formatCurrency: formatCurrency,
		formatNumber: function(num) {
			return accounting.formatNumber(num, numberFormattingSettings);
		},
		unformat: function(num) {
			return accounting.unformat(num);
		}
	}
});